import copy from 'copy-text-to-clipboard'
import { useToasts } from 'react-toast-notifications'

function useCopyText() {
  const { addToast } = useToasts()

  /**
   *
   * @param {String} text
   * @param {String} name
   * @param {Boolean} showCopiedText
   */
  function copyText(text, name = '', showCopiedText = true) {
    if (text) {
      copy(`${text}`)
      addToast(
        <div>
          Copied {name}
          <br />
          {showCopiedText && <small style={{ fontSize: 12 }}>{text}</small>}
        </div>,
        {
          appearance: 'success',
          autoDismiss: true
        }
      )
    }
  }

  return copyText
}

export default useCopyText
